<template>
    <footer class="w-full relative flex justify-center items-center">
        <div ref="goTopRef"
            class="go-top flex flex-col absolute items-center top-[75px] lg:top-[40px] right-0 cursor-pointer">
            <div class=" w-[40px]">
                <NuxtImg src="/img/all/lg-gotop.svg" alt="" class="w-full h-full object-cover" />
            </div>
            <div class="text-[clamp(14px,2vw,16px)] font-Aldrich text-skyblue">top</div>
        </div>
        <div class="absolute top-0 right-0 w-full lg:w-[95%] pointer-events-none">
            <NuxtImg src="/img/all/footer-lg.svg" alt="" class="w-full h-full object-cover" />
        </div>
        <ul
            class="flex flex-col md:flex-row  pt-[32px] pb-[5%] lg:py-[45px] items-start   w-full text-white px-[5%] lg:px-[10%] 2xl:px-[15%] 3xl:pl-[425px] gap-[clamp(10px,4vw,24px)]  2xl:gap-[clamp(32px,4vw,100px)]">
            <li class="flex  items-start gap-[5px] ">
                <div class="flex items-center gap-[5px]">
                    <h2 class="text-[clamp(14px,2vw,16px)] font-bold text-nowrap">主辦單位</h2>
                    <div class="w-[clamp(20px,2vw,40px)] h-[1px] bg-white" />
                </div>
                <div class="w-full min-w-[200px] max-w-[200px] lg:max-w-[281px]">
                    <NuxtLink to="https://www.lib.nthu.edu.tw/" target="_blank">
                        <NuxtImg src="/img/all/nthu-logo.webp" alt="" class="w-full h-full object-contain" />
                    </NuxtLink>
                </div>
            </li>
            <li class="flex  items-start gap-[5px] ">
                <div class="flex items-center gap-[5px]">
                    <h2 class="text-[clamp(14px,2vw,16px)] font-bold text-nowrap">合作單位</h2>
                    <div class="w-[clamp(20px,2vw,40px)] h-[1px] bg-white" />
                </div>
                <ul
                    class="text-[clamp(14px,2vw,16px)] font-bold text-wrap flex flex-col lg:flex-row flex-wrap gap-[12px]">
                    <li class="">國立清華大學電機資訊學院資訊工程系</li>
                    <li class="">LPWAN物聯網網路技術與應用產業聯盟</li>
                </ul>
            </li>
        </ul>
    </footer>
</template>



<script setup>
import { ref, onMounted } from 'vue'

// 滾動到頁面頂部的函數
const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滾動效果
    })
}

// 使用 ref 來引用 DOM 元素
const goTopRef = ref(null)

// 在組件掛載後綁定事件
onMounted(() => {
    if (goTopRef.value) {
        goTopRef.value.addEventListener('click', scrollToTop)
    }
})
</script>